export default "__VITE_ASSET__BD7yP$yO__"